import { render, staticRenderFns } from "./ChatterDrawer.vue?vue&type=template&id=ecbdcfd2&scoped=true"
import script from "./ChatterDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatterDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatterDrawer.vue?vue&type=style&index=0&id=ecbdcfd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbdcfd2",
  null
  
)

export default component.exports